import { render, staticRenderFns } from "./MduiSwitch.vue?vue&type=template&id=9fe3e374"
import script from "./MduiSwitch.vue?vue&type=script&lang=js"
export * from "./MduiSwitch.vue?vue&type=script&lang=js"
import style0 from "./MduiSwitch.vue?vue&type=style&index=0&id=9fe3e374&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports